import {ConditionalRule, FormComponent} from "../../DynamicFormTypes.ts";
import {cloneDeep} from "lodash";
import { useMemo} from "react";

export const useModifiedComponents = (
    components: Array<FormComponent>,
    dataGridKey: string,
    indexInDataGrid: number,
    field: Record<string, any>,
): Array<FormComponent> => {
    return useMemo(() => {

        return components.map((comp) => {
            // Create a nested field name that points to the specific row data
            const nestedFieldName = `${dataGridKey}.${indexInDataGrid}.${comp.fieldKey}`;

            //todo this needs to take in account nested rules (and or not)
            let newRule: ConditionalRule | undefined = cloneDeep(comp.conditional);
            if (newRule && newRule.when) {
                const fieldKeys = components.map(nestedComp => nestedComp.fieldKey);
                if (fieldKeys.includes(newRule.when)) {
                    newRule.when = `${dataGridKey}.${indexInDataGrid}.${newRule.when}`;
                }
            }

            // Create modified component with unique IDs and correct field paths
            return {
                ...comp,
                // Set the fieldKey to the nested path
                fieldKey: nestedFieldName,
                componentId: `${nestedFieldName}-component-${field.id}`,
                compactUI: true,
                // Generate a unique component ID for this specific field in this specific row
                conditional: newRule
            };
        });
    }, [components, dataGridKey, indexInDataGrid, field.id]);
};

